const API_URL = process.env && process.env.REACT_APP_API_HOST;
const AUTHORITY_SERVER = process.env && process.env.REACT_APP_AUTHORITY_SERVER;

function apiRequest(path, data, method) {
  //console.log('API_URL!!!', API_URL);
  // console.log('AUTHORITY_SERVER!!!', AUTHORITY_SERVER);
  let access_token = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${
        window.location.hostname.toLowerCase().includes('sabre')
          ? process.env.REACT_APP_SABRE_AUTHORITY_SERVER
          : process.env.REACT_APP_AUTHORITY_SERVER
      }:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).access_token;
  //console.log('access_token!!!', access_token);
  return fetch(`${API_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + access_token,
    },
    body: JSON.stringify(data),
  });
}

export const getRequest = (path, data) => apiRequest(path, data, 'GET');
export const postRequest = (path, data) => apiRequest(path, data, 'POST');
